import login from './login'
import usermbr from './usermbr'
import userdevice from './userdevice'
import userbelog from './userbelog'
import { isMagicbuyProject } from '@g/utils/projectUtils'

const state = {
  // signUpForm: localStorage.signUpFormGuide ? JSON.parse(localStorage.signUpFormGuide) : {
  //   fbAccessToken: '',
  //   appleIdentityToken: '',
  //   realname: '',
  // }

}

const getters = {
}

const mutations = {
}

const actions = {
  index ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/index', params)
  },
  indexAdmin ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/index-admin', params)
  },
  prepare ({ state, commit, rootState }, params) {
    return rootState.axios.get('/user/v1frontend/user/prepare', { params })
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/create', params)
  },
  /**
   * 注销
   */
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/delete', params)
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/user/v1frontend/user/view', { params })
  },
  viewNicknameCn ({ state, commit, rootState }, params) {
    return rootState.axios.get('/user/v1frontend/user/view-nickname-cn', { params })
  },
  updateDefaultWarehouseAddrid ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/usermerchant/update-default-warehouse-addrid', params)
  },
  regSaleman ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/reg-saleman', params).then(res => {
      if (res.data.jyUid) {
        localStorage.setItem('jyUid', res.data.jyUid)
      }
      return res
    })
  },
  updateRealname ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/update-realname', params)
  },
  updateNickname ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/update-nickname', params)
  },
  updateFbid ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/update-fbid', params)
  },
  sendOldCellphoneCaptcha ({ state, commit, rootState }, params) {
    if (isMagicbuyProject(rootState.project)) {
      params.site = 'MG'
    }
    return rootState.axios.post('/user/v1frontend/user/send-old-cellphone-captcha', params)
  },
  sendNewCellphoneCaptcha ({ state, commit, rootState }, params) {
    if (isMagicbuyProject(rootState.project)) {
      params.site = 'MG'
    }
    return rootState.axios.post('/user/v1frontend/user/send-new-cellphone-captcha', params)
  },
  changeCellphone ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/change-cellphone', params)
  },
  validateOldCellphoneCaptcha ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/validate-old-cellphone-captcha', params)
  },
  updateEmail ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/update-email', params)
  },
  userbelogChangeCellphoneNoLogin ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/userbelog-change-cellphone-no-login', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    login,
    usermbr,
    userdevice,
    userbelog,
  }
}
